import Grid from "@mui/material/Grid";
import Card from "@mui/material/Card";
import MDBox from "components/MDBox";
import MDTypography from "components/MDTypography";
import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
import DataTable from "examples/Tables/DataTable";
import { useEffect, useState } from "react";
import { getUsers } from "api/api";
import getAdminsTableData from "./data/adminsTableData";
import MDButton from "components/MDButton";
import CreateAdminForm from "./create_admin_form";
import UpdateAdminForm from "./update_admin_form";
import { CheckPermissionRender } from "../../helpers/checkPermission";
import permissions from "../../config/permissions";
import { getUserPermissionsCall } from "../../api/api";
import AdminPermissions from "./admin_permissions";
import MobileNavbar from "examples/Navbars/MobileNavbar";
import { useIsMobile } from "hooks/useIsMobile";

function SystemAdmins() {
  const [state, setState] = useState({
    columns: [],
    rows: [],
    createModalOpen: false,
  });

  const [userToEdit, setUserToEdit] = useState(null);
  const [permissionState, setPermissionState] = useState({
    user: null,
    userPermissions: [],
    allPermissions: [],
  });
  const isMobile = useIsMobile();

  const getAllUsers = async () => {
    const users = await getUsers();
    if (users) {
      const { columns, rows } = getAdminsTableData(users, onEdit, onViewPermission);
      setState({ ...state, columns: columns, rows: rows, createModalOpen: false });
      setUserToEdit(null);
      setPermissionState({ ...state, user: null, allPermissions: [], userPermissions: [] });
    }
  };
  useEffect(() => {
    getAllUsers();
  }, []);

  const createModel = (open) => {
    setState({ ...state, createModalOpen: open });
  };

  const onEdit = (user) => {
    setUserToEdit(user);
  };

  const onViewPermission = async (user) => {
    const permissions = await getUserPermissionsCall(user.id);
    setPermissionState({
      ...permissionState,
      user: user,
      allPermissions: permissions.all_permissions,
      userPermissions: permissions.user_permissions,
    });
  };

  return (
    <DashboardLayout>
      <MobileNavbar />
      <MDBox pt={6} pb={3}>
        <Grid container spacing={6}>
          <Grid item xs={12}>
            <Card>
              <MDBox
                mx={2}
                mt={-3}
                py={2}
                px={2}
                variant="gradient"
                bgColor="info"
                borderRadius="lg"
                coloredShadow="info"
                display="flex"
                justifyContent="space-between"
                alignItems={isMobile ? "left" : "center"}
                flexDirection={isMobile ? "column" : "row"}
                gap={1}
              >
                <MDTypography variant="h6" color="white">
                  System Admins
                </MDTypography>
                <CheckPermissionRender permissions={permissions().systemAdmin().create().list()}>
                  <MDButton
                    onClick={() => {
                      createModel(true);
                    }}
                    variant="gradient"
                    color="dark"
                    style={{ width: "fit-content" }}
                  >
                    add new user
                  </MDButton>
                </CheckPermissionRender>
              </MDBox>
              <MDBox pt={3}>
                <DataTable
                  table={{ columns: state.columns, rows: state.rows }}
                  isSorted={false}
                  entriesPerPage={false}
                  showTotalEntries={false}
                  noEndBorder
                />
              </MDBox>
            </Card>
          </Grid>
        </Grid>
      </MDBox>
      {/* <Footer /> */}
      <CheckPermissionRender permissions={permissions().systemAdmin().create().list()}>
        <CreateAdminForm
          open={state.createModalOpen}
          onClose={() => {
            createModel(false);
          }}
          reload={getAllUsers}
        />
      </CheckPermissionRender>
      <CheckPermissionRender permissions={permissions().systemAdmin().update().list()}>
        <UpdateAdminForm
          user={userToEdit}
          onClose={() => {
            setUserToEdit(null);
          }}
          reload={getAllUsers}
        />
      </CheckPermissionRender>
      <CheckPermissionRender
        permissions={permissions().rolePermission().create().read().update().list()}
      >
        <AdminPermissions
          user={permissionState.user}
          userPermissions={permissionState.userPermissions}
          allPermissions={permissionState.allPermissions}
          onClose={() => {
            setPermissionState({ ...state, user: null, allPermissions: [], userPermissions: [] });
          }}
          reload={getAllUsers}
        />
      </CheckPermissionRender>
    </DashboardLayout>
  );
}

export default SystemAdmins;
